import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/organization/')({
  component: () => <Navigate to="/organization/overview" search={true} />,
})
